import { useMemo, useState } from "react";
import { boardItems } from "@/mocks/home";
import HotRanking from "./HotRanking";

const statusStyle: Record<string, string> = {
  已展示: "bg-secondary-100 text-secondary-900",
  待补充: "bg-accent-100 text-accent-900",
  待核实: "bg-background-200 text-foreground-700",
};

export default function ExposureBoard() {
  const categories = useMemo(() => {
    const tags = Array.from(new Set(boardItems.map((item) => item.tag)));
    return ["全部", ...tags];
  }, []);
  const [active, setActive] = useState("全部");

  const visibleItems = useMemo(
    () => (active === "全部" ? boardItems : boardItems.filter((item) => item.tag === active)),
    [active],
  );

  return (
    <section id="board" className="px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="text-xs md:text-sm font-medium tracking-wide text-primary-600">
              曝光台
            </span>
            <h3 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              审核通过的线索，按标题与摘要公开展示
            </h3>
          </div>
          <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
            每条线索都带编号与状态，敏感信息在展示前已统一脱敏，仅保留可核实的部分。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          <div className="lg:col-span-8">
            <div className="flex flex-wrap gap-2">
              {categories.map((category) => {
                const isActive = category === active;
                return (
                  <button
                    key={category}
                    type="button"
                    onClick={() => setActive(category)}
                    className={`px-3.5 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                      isActive
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-50 text-foreground-700 border border-background-200 hover:border-primary-300"
                    }`}
                  >
                    {category}
                  </button>
                );
              })}
            </div>

            <ul className="mt-5 space-y-3.5">
              {visibleItems.map((item) => (
                <li
                  key={item.id}
                  className="rounded-lg bg-background-50 border border-background-200 p-4 md:p-5 transition-colors hover:border-primary-300"
                >
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="px-2.5 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span
                      className={`px-2.5 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${
                        statusStyle[item.status] ?? "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {item.status}
                    </span>
                    <span className="ml-auto flex items-center gap-1 text-xs text-foreground-500 whitespace-nowrap">
                      <i className="ri-time-line text-sm"></i>
                      {item.time}
                    </span>
                  </div>

                  <h4 className="mt-3 font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug">
                    {item.title}
                  </h4>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>

                  <div className="mt-4 flex items-center justify-between gap-3">
                    <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                      <i className="ri-fire-line text-base text-accent-600"></i>
                      热度 {item.heat.toLocaleString("zh-CN")}
                    </span>
                    <a
                      href="#submit"
                      className="flex items-center gap-1 text-xs font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
                    >
                      补充材料
                      <i className="ri-arrow-right-line text-sm"></i>
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <aside className="lg:col-span-4">
            <HotRanking />
          </aside>
        </div>
      </div>
    </section>
  );
}